import { injectable, interfaces } from 'inversify';
import { computed, makeObservable, observable } from 'mobx';
import { InputStatus } from '../../models/error.model';
import { Plan } from '../user/user.store';
import { IImageFile } from './imagesUpload.service';
import { IRejectedFile } from './models/IRejectedFile';

export namespace IDatasetDraftsStore {
  export const $: interfaces.ServiceIdentifier<IDatasetDraftsStore> = Symbol('DATASET_DRAFTS_STORE');
}

export interface IDatasetDraft {
  id: string;
  externalStatus: InputStatus;
  workspaceId: string;
  name: string;
  description: string;
  nameStatus: InputStatus;
  images: IImageFile[];
  imagesToUploadFromFile: IImageFile[];
  imagesRejectedFromFile: IRejectedFile[];
  willExceedsUploadImageSizeLimit: boolean;
  imagePreValidationWasSuccessful: boolean;
  ownerPlan: Plan;
  termsOfUse: string;
  author: string;
}

export interface IDatasetDraftsStore {
  draft: IDatasetDraft;
  isValid: boolean;
}

@injectable()
export class DatasetDraftsStore implements IDatasetDraftsStore {
  draft: IDatasetDraft = {
    ownerPlan: Plan.Free,
    workspaceId: '',
    nameStatus: InputStatus.empty(),
    externalStatus: InputStatus.empty(),
    name: `Dataset ${new Date().toLocaleString()}`,
    id: '',
    description: '',
    images: [],
    imagesToUploadFromFile: [],
    imagesRejectedFromFile: [],
    willExceedsUploadImageSizeLimit: false,
    imagePreValidationWasSuccessful: true,
    author: '',
    termsOfUse: '',
  };

  constructor() {
    makeObservable(this, {
      draft: observable,
      isValid: computed,
    });
  }

  get isValid(): boolean {
    return this.draft.imagesToUploadFromFile.length > 0 && this.draft.nameStatus.errorCodes.length === 0;
  }
}
